import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogType, MediDialogComponent } from '../../medi-dialog/medi-dialog.component';
import { OroService } from '../../oroservice';
import { DialogAbsenceComponent } from '../dialog-absence/dialog-absence.component';

export interface DialogData {
    behandler: any;
}

@Component({
    selector: 'app-dialog-doctor',
    templateUrl: './dialog-doctor.component.html',
    styleUrls: ['./dialog-doctor.component.scss'],
    standalone: false
})
export class DialogDoctorComponent implements OnInit {

    Behandler: any = {};
    private saving: boolean = false;

    constructor(public dialogRef: MatDialogRef<DialogAbsenceComponent>, public oroservice: OroService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData, public dialog: MatDialog) { }

    ngOnInit(): void {
        this.Behandler = this.data.behandler;
    }

    public canSubmit(): boolean {
        return !(!this.Behandler.Vorname || this.Behandler.Vorname.length < 2
            || this.Behandler.Name.length < 2
            || this.Behandler.Anrede === 0
            || this.Behandler.Fachrichtung === 0
        );
    }

    saveBehandler() {
        this.saving = true;

        this.oroservice.setBehandler(this.Behandler).then((object) => {
            //this.NewBehandler();
            this.dialogRef.close(true);
        });
    }

    clickSave() {
        if (this.saving) {
            return;
        }
        else if (this.Behandler.Id > 0) {
            this.openDialogSaveBehandler();
        } else {
            this.saveBehandler();
        }
    }

    openDialog(paramWidth: string, paramTitle: string, paramContent: string, paramYes: string, paramNo: string, paramType: DialogType = DialogType.None): Observable<boolean> {
        const dialogRef = this.dialog.open(MediDialogComponent, {
            width: paramWidth,
            data: { title: paramTitle, content: paramContent, yes: paramYes, no: paramNo, type: paramType }
        });

        return dialogRef.afterClosed();
    }

    openDialogSaveBehandler() {
        if (this.Behandler.Id < 0) {
            this.saveBehandler();
        }
        else {
            this.openDialog("500px", "Aufträge.NachfrageBehandlerBearbeiten", "Aufträge.NachfrageBehandlerBearbeitentext", "OK", "Abbrechen", DialogType.Question).subscribe(result => {
                if (result) {
                    this.saveBehandler();
                }
            });
        }
    }
}
